import { useContext } from 'react';
import { ConfigContext } from '../components/ConfigProvider';

export const useConfigValue = () => useContext(ConfigContext);
export default useConfigValue;
